import type { RoleCategory } from './types';

/**
 * Classify a free-form role string into a seniority tier.
 *
 * Accepts any string input — free-form role_name from system_users
 * (e.g. "Performance Marketing Specialist"), the HiringRole enum values
 * ("Manager" | "Strategist" | "Lead" | "Specialist"), or short grade strings
 * like "Associate Director".
 *
 * Matching is case-insensitive substring, applied in senior-first priority
 * order so that ambiguous inputs resolve to the more-senior label:
 *   director > manager > strategist > lead > specialist > other
 *
 * Null, undefined, empty, and whitespace-only inputs return 'other'.
 */
export function classifyRole(raw: string | null | undefined): RoleCategory {
  if (raw === null || raw === undefined) return 'other';
  const normalized = raw.toLowerCase().trim();
  if (normalized.length === 0) return 'other';

  if (normalized.includes('director')) return 'director';
  if (normalized.includes('manager')) return 'manager';
  if (normalized.includes('strategist')) return 'strategist';
  if (normalized.includes('lead')) return 'lead';
  if (normalized.includes('specialist')) return 'specialist';

  return 'other';
}
